import { render, staticRenderFns } from "./AttentionIcon.vue?vue&type=template&id=33dc8e65"
import script from "./AttentionIcon.vue?vue&type=script&lang=js"
export * from "./AttentionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports